import { render, staticRenderFns } from "./SectionContactV1.vue?vue&type=template&id=7fa7c037&"
import script from "./SectionContactV1.vue?vue&type=script&lang=js&"
export * from "./SectionContactV1.vue?vue&type=script&lang=js&"
import style0 from "./SectionContactV1.vue?vue&type=style&index=0&id=7fa7c037&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrganismsProjectOrganismContactForm: require('/app/components/organisms/project/OrganismContactForm.vue').default,OrganismsPortfolioOrganismTeam: require('/app/components/organisms/portfolio/OrganismTeam.vue').default,AtomsCommonAtomLegalLinks: require('/app/components/atoms/common/AtomLegalLinks.vue').default,AtomsCommonAtomIcon: require('/app/components/atoms/common/AtomIcon.vue').default,AtomsCommonAtomButton: require('/app/components/atoms/common/AtomButton.vue').default})
